import { useState } from 'react';
import { notification } from 'antd';
import FileSaver from 'file-saver';
import { MSG_ERROR } from '../../constants';
import { getApiErrorMessage } from '../../utils/httpError';
import { closeLoadingNotification, openLoadingNotification } from '../../utils/loadingNotification';

export default ({ children, fileName, exportFile }) => {
  const [exporting, setExporting] = useState(false);

  const onExport = async () => {
    if (exporting) {
      return;
    }
    setExporting(true);
    openLoadingNotification({ key: 'exporting', message: 'Exporting' });
    try {
      const res = await exportFile();
      const blob = new Blob([res.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      FileSaver.saveAs(blob, fileName);
      closeLoadingNotification('exporting');
      notification.success({
        key: 'export_success',
        message: 'Export successfully'
      });
    } catch (err) {
      closeLoadingNotification('exporting');
      notification.error({
        key: 'export_fail',
        message: 'Export failed',
        description: getApiErrorMessage(err, MSG_ERROR)
      });
    }
    setExporting(false);
  };

  return children(onExport);
};
